export const POPULUS_TEAL = 'rgb(28, 156, 144)'
